import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "@/PageResizeConfig";
import "@/sweetAlertMutationObserver";
import GlobalConfig from '@/GlobalConfig';

//#region Application Insight Config
import "@/plugins/ApplicationInsight/ApplicationInsight";

//#endregion

//#region Custom Styles
import '@/assets/css/main.css';
// import '@/assets/css/style.css';
// import '@/assets/css/custom/inputs.css';
// import '@/assets/css/custom/buttons.css';
// import '@/assets/css/custom/tables.css';
// import '@/assets/css/vue-multiselect/vue-multiselect-custom.css';
// import '@/assets/css/filepond/filepond-custom.css';
// import '@/assets/css/vue-form-wizard/vue-form-wizard-custom.css';
//#endregion

//#region Icons
// https://fontawesome.com/icons?d=gallery
import '@/assets/css/font-awesome.min.css';
// https://themify.me/themify-icons
import '@/assets/css/themify-icons.css';
//#endregion

//#region Bootstrap
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/css/bootstrap/bootstrap-pagination.css';
import '@/assets/css/bootstrap/bootstrap-popover.css';
//#endregion

//#region BootstrapVue: https://bootstrap-vue.org/
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BootstrapVue } from 'bootstrap-vue';
Vue.use(BootstrapVue);
//#endregion

//#region Vue Form Wizard: https://binarcode.github.io/vue-form-wizard/#/
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
Vue.use(VueFormWizard);
//#endregion

//#region Vue Multiselect: https://vue-multiselect.js.org/
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);
//#endregion

//#region AnimateCSS: https://animate.style/
import 'animate.css';
//#endregion

//#region Moment.js: https://momentjs.com/
import * as moment from 'moment';
moment.locale('es');
//#endregion

//#region FilePond: https://pqina.nl/filepond/docs/patterns/frameworks/vue/
import 'filepond-polyfill';
// Import FilePond
import vueFilePond from 'vue-filepond';
// Import styles
import '@/assets/css/filepond/filepond.min.css';
// Create FilePond component
const FilePond = vueFilePond();
Vue.component('file-pond', FilePond);
//#endregion

//#region VeeValidate: https://logaretm.github.io/vee-validate/
import '@/vee-validate';
//#endregion

//#region VUE DATAPICKER

//#region Chart.js
import {  Chart,
	LinearScale,
	LogarithmicScale,
	RadialLinearScale,
	TimeScale,
	Tooltip} from 'chart.js';

//#endregion

//#region Loading Button
import LoadingButton from '@/components/LoadingButton.vue';
Vue.component('loading-button', LoadingButton);
//#endregion

//#region Swipe Animation
import SwipeAnimation from '@/components/SwipeAnimation.vue';
Vue.component('SwipeAnimation', SwipeAnimation);
//#endregion

//#region Archivo Solicitud Card
import ArchivoSolicitudCard from '@/components/ArchivoSolicitudCard.vue';
Vue.component('ArchivoSolicitudCard', ArchivoSolicitudCard);
//#endregion

//Inject Axios in $http
import Axios from "axios";
Vue.prototype.$http = Axios;
//

// Import OpenCV.js
import * as cv from 'opencv.js'; // Importa OpenCV.js

// Extender window para incluir OpenCV.js globalmente
declare global {
  interface Window {
    cv: typeof cv;
  }
}

// Asignar OpenCV al objeto global window
window.cv = cv;

// Verificar si OpenCV.js está listo
cv['onRuntimeInitialized'] = () => {
  console.log('OpenCV.js is ready to use!');
};


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
